// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.


(function ($, Drupal) {
  Drupal.behaviors.disableBefAutoSubmitForDate = {
    attach: function (context, settings) {
      $('#edit-field-event-date-value').attr('data-bef-auto-submit-exclude', '');
      $('#edit-field-event-date-value-2').attr('data-bef-auto-submit-exclude', '');
    }
  };
  Drupal.behaviors.toggleSearch = {
    attach: function (context, settings) {
      once('toggleSearch', '.search-toggler', context).forEach(function (element) {
        $(element).on('click', function () {
          var targetId = $(this).attr('aria-controls');
          var $target = $('.' + targetId);
          var isExpanded = $(this).attr('aria-expanded') === 'true';

          $(this).attr('aria-expanded', !isExpanded);

          $target.toggleClass('show');

          if (!isExpanded) {
            $target.find('input[type="text"]').focus();
          }
        });
      });
    }
  };
})(jQuery, Drupal);